import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// @ts-ignore
import { getRouterData as getDefaultRouters } from "hzero-front/lib/utils/router"; // @ts-ignore

import { getRouterData } from '@root-src-utils-router';
export function getWrapperRouterData(app) {
  if (getRouterData.beforeLoad) {
    getRouterData.beforeLoad(app);
  }
  return _objectSpread(_objectSpread({}, getDefaultRouters(app)), getRouterData(app));
}